module.exports = __webpack_public_path__ + "static/media/9.e98c6ecc.jpg";